// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f1235fff","457":"04ac052b","551":"95c16de2","760":"6495bfa4","940":"2417c7ca"}[chunkId] + ".chunk.js";
};